import React from 'react'
import PropTypes from 'prop-types'

const MobileSlashBillBox = (props) => {
    return (
        <div className={`${props.className} slash-mobile-container`}>
            {props.show
                ? <div className='m-auto px-3 pt-3 img-container'>
                    <img src={`${props.imgUrl}`} alt='slashBill' />
                  </div>
                : <div className='mobile-title-top-box'>
                    <h3 className='text-center bold d-none d-lg-block m-0' dangerouslySetInnerHTML={{ __html: props.title }} />
                    <h3 className='text-center color-lime bold d-block d-lg-none m-0' dangerouslySetInnerHTML={{ __html: props.mobileTitle }} />
                  </div>}
            {props.children}
        </div>
    )
}

MobileSlashBillBox.propTypes = {
    className: PropTypes.string,
    show: PropTypes.bool,
    title: PropTypes.string,
    mobileTitle: PropTypes.string,
    children: PropTypes.node.isRequired
}

export default MobileSlashBillBox



// WEBPACK FOOTER //
// ./resources/js/components/MobileSlashBillBox.js